module.exports = __webpack_public_path__ + "static/media/Elsa Higareda.1ff4fcbf.jpg";